import { ALFactoryGlobal, IAugLoopRuntimeManager } from '@augloop/office-online';
import { AddOperation, Document } from '@augloop/types-core';
import { APP_VERSION, APP_INTERNAL_NAME } from '../../AppConstants';
import { AugloopError, AugloopErrors } from './AugloopErrors';
import { LogEvents } from '../../utils/LogEvents';
import { AugloopKeys } from './telemetry/AugloopKeys';
import { v4 as uuidv4 } from 'uuid';
import { OTelTelemetryLogger } from '../TelemetryLogger/Details/OTelTelemetryLogger';
import { getLoggerInstanceForAugLoop } from '../TelemetryLogger/Details/Logger';
import { DurationMeasureType } from '../interfaces/ILogEvent';

let initializeRuntimeManagerTask: Promise<void> = null;

// Create a document tile in the session. This is the root of all subsequent tiles that will be created.
function SubmitDocumentTile(runtimeManager: IAugLoopRuntimeManager) {
  const documentTile = new Document({
    isReadonly: false
  });

  const documentOperation = new AddOperation({
    parentPath: ['session'],
    items: [
      {
        id: 'doc',
        body: documentTile
      }
    ]
  });
  runtimeManager.submitOperation({ operation: documentOperation });
}

export async function GetInitializeRuntimeManagerTask(): Promise<void> {
  return initializeRuntimeManagerTask;
}

// After calling this function, the caller should call GetInitializeRuntimeManagerTask and await it before using Augloop
export function InitializeRuntimeManager(serviceUrl: string): void {
  const guid: string = uuidv4();
  LogEvents.Augloop.Start([{ key: AugloopKeys.SessionGuid, value: guid}, { key: AugloopKeys.ServiceUrl, value: serviceUrl}]);
  LogEvents.Augloop.BeginDurationMeasure(DurationMeasureType.Normal, AugloopKeys.InitializeAugloopRuntimeManagerDuration);
  initializeRuntimeManagerTask = new Promise((resolve, reject) => {
    const alRuntimeManager: IAugLoopRuntimeManager = ALFactoryGlobal.getAugLoopRuntimeManager();

    // Give AL 30 seconds to initialize a session. Fail otherwise.
    const timeoutHandle = setTimeout(() => {
      reject(new AugloopError(AugloopErrors.SessionInitTimeout, 'Timeout when initializing augloop session'));
    }, 30000);

    alRuntimeManager.setSendOTelEventCallback({
      sendOTelEvent: (<OTelTelemetryLogger>getLoggerInstanceForAugLoop()).LogEventCallbackForAL
    });

    alRuntimeManager. setSessionDataCallback({
      handler: undefined,
      sessionDataCallback: (sessionUrl: string, _origin: string, _authToken: string): void => {
        LogEvents.Augloop.AddData([{ key: AugloopKeys.SessionUrl, value: sessionUrl}]);
        clearTimeout(timeoutHandle);
        LogEvents.Augloop.End();
        resolve();
      }
    });

    const augloopRuntimeConfig = {
      serviceUrl,
      appName: APP_INTERNAL_NAME,
      appVersion: APP_VERSION,
      releaseAudienceGroup: '',
      releaseChannel: '',
      releaseFork: '',
      sessionId: guid,
      initSession: true,
    };
    
    alRuntimeManager.initialize(augloopRuntimeConfig);
    SubmitDocumentTile(alRuntimeManager);
  });
}